<div class="text-center pt-md-5 pt-lg-1" *ngIf="showSocialIconsCopyright" [ngClass]="themeClass('subfooter-section1')">
    <div class="subfooter-logo row footer-logos">
        <div class="col-lg-3 col-md-3 col-sm-12  d-flex justify-content-center pt-3  pb-md-0 ">
            <img [src]="commonImagePath + 'sub_footer_logo.webp'" alt="logo" class="subfooter-logo">
        </div>
    </div>


    <ng-container *ngIf="chTheme1">
        <img [src]="imgBasePath + 'genuine-part-logo.webp'" alt="logo" class="chevi-footer-logo">
        <img [src]="imgBasePath + 'chevrolet_logo.webp'" alt="gm-logo">
    </ng-container>
    <ng-container *ngIf="chTheme3 || chTheme4 || chTheme11 || chTheme15">
        <img [src]="imgBasePath + 'member.webp'" alt="logo" class="thp-logo">
    </ng-container>
    <p class="small mt-3 mb-0 copyright-text heri-copyright" [innerHTML]="menuLink"></p>
</div>